import { Component, OnInit } from '@angular/core';
import { BitacoraActividadesInterface } from 'app/models/bitacora.model';
import { Observable } from 'rxjs';
import { DetalleTareaService } from '../../../detalle-tareas-service';
import { CommonModule } from '@angular/common';
import { ActividadRecienteComponent } from 'app/modules/SharedEntitiesComponents/actividad-reciente/actividad-reciente';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'actividad-tarea',
    templateUrl: 'actividad-tarea.component.html',
    imports:[
        CommonModule,
        ActividadRecienteComponent
    ]
})

export class ActividadesTareaComponent implements OnInit {
    actividadTareas$!: Observable<BitacoraActividadesInterface[]>;

    constructor(private detalleTareasService: DetalleTareaService) {
        this.actividadTareas$ = this.detalleTareasService._actividaTarea$;
    }

    ngOnInit() { }
}